import DesignTeamUsersSearch from '../components/DesignTeamUsersSearch'
import DesignTeamUsersUpdate from '../components/DesignTeamUsersUpdate'

export default class DesignTeams {
  show() {
    N2.bindGlobalHandler('pm:design-team-search', () => {
      new DesignTeamUsersSearch(event.detail)
    })
    N2.bindGlobalHandler('pm:design-team-update', (evt) => {
      new DesignTeamUsersUpdate(event.detail)
    })
  }
}
